import { getReviewFlagLabel } from '@/utils/docReviewFilterPills'

export const BLOCKING_REVIEW_FLAG_KEYS = new Set([
  'missing_line_items',
  'missing_vendor',
  'missing_location',
  'missing_bill_dates',
  'missing_categories',
  'unallocated_shared_costs',
])

export const PURCHASING_ONLY_REVIEW_FLAG_KEYS = new Set([
  'duplicate_content',
  'order_version',
  'pre_delivery',
  'new_reader_model_path',
  'enrichment_pending',
  'enrichment_needs_review',
  'enrichment_failed',
])

export const BULK_WARN_ONLY_EXACT_FLAGS = new Set([
  ...PURCHASING_ONLY_REVIEW_FLAG_KEYS,
  'scan_field_repaired',
])

export function isTotalMismatchReviewFlag(flag: string): boolean {
  return flag.startsWith('total_validation_mismatch:')
}

export function isPurchasingOnlyReviewFlag(flag: string): boolean {
  return PURCHASING_ONLY_REVIEW_FLAG_KEYS.has(flag)
}

export function isBlockingReviewFlag(flag: string): boolean {
  return BLOCKING_REVIEW_FLAG_KEYS.has(flag)
}

export function isBulkWarnOnlyReviewFlag(flag: string): boolean {
  return isTotalMismatchReviewFlag(flag) || BULK_WARN_ONLY_EXACT_FLAGS.has(flag)
}

export function getAmberReviewFlagsFromNeedsReviewFlags(flags: string[]): string[] {
  return flags.filter(
    (f) => !isBlockingReviewFlag(f) && !isPurchasingOnlyReviewFlag(f),
  )
}

export function formatAmberReviewFlagLine(flag: string): string {
  return getReviewFlagLabel(flag)
}
